import { apiSlice } from '../../../app/api/apiSlice';
import Config from '../../../configs/appConfig';
import makeQueryParams from '../../../lib/makeQueryParams';



export const LogsApiSlice = apiSlice.injectEndpoints({
  tagTypes: [ 'Logs', 'LogsItem' ],
  endpoints: (builder) => {
    return ({
      getLogs: builder.query({
        query: (params) => {
          const queryParams = makeQueryParams(params.queryParams);

          return ({ url: `/${Config.VITE_HC_API_VERSION}/logs${queryParams}` });
        },
        transformResponse: (response) => {
          return {
            data: response?.data,
            pagination: response?.meta?.pagination,
            customOptions: response?.meta?.custom,
          };
        },
        transformErrorResponse: (response) => response?.data?.errors,
        providesTags: [ 'Logs' ],
        keepUnusedDataFor: 1,
      }),
      getSpecificLog: builder.query({
        query: (logId) => ({ url: `/${Config.VITE_HC_API_VERSION}/logs/${logId}` }),
        transformResponse: (response) => response.data,
        providesTags: [ 'LogsItem' ],
      }),
    });
  },
});

export const {
  useGetLogsQuery,
  useGetSpecificLogQuery,
} = LogsApiSlice;
